/*install-turborepo*/
/*choose-your-learning-path*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "入门",
  "description": "开始使用 Turborepo。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "如果你是 Turborepo 新手，可以按照以下步骤开始使用。"
  }, {
    "heading": "",
    "content": "¥If you're new to Turborepo, you can follow these steps to get started."
  }, {
    "heading": "安装-turborepo-install-turborepo",
    "content": "¥Install Turborepo"
  }, {
    "heading": "安装-turborepo-install-turborepo",
    "content": "全局安装 turbo，以便你可以在存储库中的任何位置方便地在终端中运行 turbo 命令。"
  }, {
    "heading": "安装-turborepo-install-turborepo",
    "content": "¥Install turbo globally so you can conveniently run turbo commands in your terminal from anywhere in your repository."
  }, {
    "heading": "安装-turborepo-install-turborepo",
    "content": "要了解更多关于安装 turbo 的信息，请参阅 安装指南。"
  }, {
    "heading": "安装-turborepo-install-turborepo",
    "content": "¥To learn more about installing turbo, see the installation guide."
  }, {
    "heading": "选择你的学习路径-choose-your-learning-path",
    "content": "¥Choose your learning path"
  }],
  "headings": [{
    "id": "安装-turborepo-install-turborepo",
    "content": "安装 Turborepo /*install-turborepo*/"
  }, {
    "id": "选择你的学习路径-choose-your-learning-path",
    "content": "选择你的学习路径 /*choose-your-learning-path*/"
  }]
};
import {Card, Cards} from '#components/card';
import {Step, Steps} from '#components/steps';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#安装-turborepo-install-turborepo",
  title: _jsx(_Fragment, {
    children: "安装 Turborepo "
  })
}, {
  depth: 2,
  url: "#选择你的学习路径-choose-your-learning-path",
  title: _jsx(_Fragment, {
    children: "选择你的学习路径 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "如果你是 Turborepo 新手，可以按照以下步骤开始使用。"
    }), "\n", _jsx(_components.p, {
      children: "¥If you're new to Turborepo, you can follow these steps to get started."
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h2, {
          id: "安装-turborepo-install-turborepo",
          children: "安装 Turborepo "
        }), _jsx(_components.p, {
          children: "¥Install Turborepo"
        }), _jsxs(_components.p, {
          children: ["全局安装 ", _jsx(_components.code, {
            children: "turbo"
          }), "，以便你可以在存储库中的任何位置方便地在终端中运行 ", _jsx(_components.code, {
            children: "turbo"
          }), " 命令。"]
        }), _jsxs(_components.p, {
          children: ["¥Install ", _jsx(_components.code, {
            children: "turbo"
          }), " globally so you can conveniently run ", _jsx(_components.code, {
            children: "turbo"
          }), " commands in your terminal from anywhere in your repository."]
        }), _jsxs(Tabs, {
          items: ["npm", "yarn", "pnpm"],
          storageKey: "selected-pkg-manager",
          children: [_jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " global"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["要了解更多关于安装 ", _jsx(_components.code, {
            children: "turbo"
          }), " 的信息，请参阅 ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "安装指南"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥To learn more about installing ", _jsx(_components.code, {
            children: "turbo"
          }), ", see the ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "installation guide"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h2, {
          id: "选择你的学习路径-choose-your-learning-path",
          children: "选择你的学习路径 "
        }), _jsx(_components.p, {
          children: "¥Choose your learning path"
        }), _jsxs(Cards, {
          children: [_jsx(Card, {
            href: "/docs/getting-started/installation",
            title: "Use create-turbo",
            description: "Start with a template"
          }), _jsx(Card, {
            href: "/docs/getting-started/examples",
            title: "Use an example",
            description: "Start with a framework-specific example"
          }), _jsx(Card, {
            href: "/docs/crafting-your-repository",
            title: "Follow the in-depth guides",
            description: "From zero to monorepo"
          }), _jsx(Card, {
            href: "/docs/getting-started/add-to-existing-repository",
            title: "Add to an existing repository",
            description: "Make your current repo fast"
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
